import React from "react";
import { Card, Button, Typography, Space, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

export default function DeleteServer() {
  const confirmDelete = () => {
    Modal.confirm({
      title: "Delete Server",
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          <Paragraph>
            Deleting your server will stop any existing processes and destroy
            the disk data and backups.
          </Paragraph>
          <Paragraph>
            <Text strong>
              This action cannot be undone. Snapshots will remain intact.
            </Text>
          </Paragraph>
        </>
      ),
      okText: "Delete server",
      okType: "danger",
      cancelText: "Cancel",
    });
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Card>
        <Title level={5}>DELETE</Title>

        <Paragraph>
          Deleting your server will stop any existing processes and destroy the
          disk data and backups.
        </Paragraph>

        <Paragraph type="secondary">
          The data won’t be retrievable – snapshots of the server remain intact.
        </Paragraph>

        <Button danger type="primary" onClick={confirmDelete}>
          Delete server
        </Button>
      </Card>
    </Space>
  );
}
